import styled from '@emotion/styled'
import { css } from '@emotion/react'

const iconExtraStyles = ({ theme }) => css`
  position: absolute;
  top: 0;
  right: 0;
  svg {
    display: block;
    width: 14px;
    height: 14px;
    margin-top: 10px;
    margin-right: 12px;
    color: ${theme.colors.n300};
    pointer-events: none;
  }
`
export const IconExtra = styled('div')(iconExtraStyles)

const iconShareStyles = () => css`
  cursor: pointer;
`

export const IconShare = styled('div')(iconShareStyles)

const groupDescriptionStyles = () => css`
  max-width: 5.938rem;
`

export const GroupDescription = styled('div')(groupDescriptionStyles)

const pictureStyles = ({ theme }) => css`
  position: relative;
  width: 95px;
  height: 95px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${theme.colors.n100};
  border-radius: 50px;
  cursor: pointer;
`

export const Picture = styled('div')(pictureStyles)

const pictureImageStyles = ({ theme }) => css`
  img,
  svg {
    display: block;
    width: 100%;
    height: 100%;
  }
  img {
    border-radius: 50px;
  }
  svg {
    padding: 10px;
    color: ${theme.colors.v700};
    fill: ${theme.colors.v700};
  }
`
export const PictureImage = styled('div')(pictureImageStyles)

const pictureIconStyles = ({ theme }) => css`
  position: absolute;
  left: 0;
  bottom: 0;
  width: 28px;
  height: 28px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.colors.n300};
  border-radius: 50px;
  background: ${theme.colors.white};
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.25);
  transition: background ease-in 300ms;
`
export const PictureIcon = styled('div')(pictureIconStyles)

const contentStyles = () => css`
  margin-top: 16px;
  margin-bottom: 32px;
`

export const Content = styled('div')(contentStyles)

const titleStyles = ({ theme }) => css`
  display: block;
  margin-bottom: 8px;
  font-size: 16px;
  font-weight: ${theme.font.weight.semibold};
  line-height: 19px;
  text-align: center;
  color: ${theme.colors.black};
  transition: color ease 300ms;
  user-select: none;
`
export const Title = styled('span')(titleStyles)

const descriptionStyles = ({ theme }) => css`
  display: block;
  font-size: 12px;
  line-height: 18px;
  text-align: center;
  color: ${theme.colors.n400};
  transition: color ease 300ms;
  div {
    margin-bottom: 8px;
  }
`

export const Description = styled('span')(descriptionStyles)

const dividerStyles = ({ theme }) => css`
  position: relative;
  width: calc(100% + 36px);
  height: 2px;
  margin: 0 -18px;
  color: ${theme.colors.n100};
  background-size: contain;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23EEEEF0' viewBox='0 0 12 2'%3E%3Crect width='8' height='2' x='2' rx='1'/%3E%3C/svg%3E%0A");
  background-repeat: repeat-x;
  background-position: center;
  &::before,
  &::after {
    content: '';
    position: absolute;
    top: -5px;
    width: 6px;
    height: 12px;
    background: ${theme.colors.white};
    border: 1px solid ${theme.colors.n100};
  }
  &:before {
    left: -7px;
    border-bottom-right-radius: 12px;
    border-top-right-radius: 12px;
    border-left: 0;
  }
  &:after {
    right: -7px;
    border-bottom-left-radius: 12px;
    border-top-left-radius: 12px;
    border-right: 0;
  }
  path {
    stroke: ${theme.colors.n100};
  }
`

export const Divider = styled('div')(dividerStyles)

const bottomStyles = () => css`
  padding-top: 16px;
`

export const Bottom = styled('div')(bottomStyles)

const textFooterStyles = () => css`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin-top: 8px;

  svg {
    position: relative;
    top: 1px;
    margin-right: 4px;
  }
  div {
    margin-bottom: 0;
  }
`
export const TextFooter = styled(Description)(textFooterStyles)

const buttonIconStyles = () => css`
  svg {
    width: 16px;
    height: 12px;
    margin-right: 8px;
  }
`
export const ButtonIcon = styled('div')(buttonIconStyles)

export const baseStyles = ({ theme }) => css`
  align-items: center;
  position: relative;
  width: 180px;
  height: 340px;
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  border: 1px solid ${theme.colors.n100};
  border-radius: 4px;
  background: ${theme.colors.white};
  transition: border-color ease 300ms;
`

const baseActiveStyles = ({ theme, isActive }) =>
  isActive &&
  css`
    border-color: transparent;
    background-image: linear-gradient(
      150deg,
      ${theme.colors.f700} 5%,
      ${theme.colors.v500} 100%
    );
    ${IconExtra} svg {
      color: ${theme.colors.white};
    }
    ${Picture} {
      border-color: ${theme.colors.f500};
    }
    ${PictureImage} svg {
      color: ${theme.colors.white};
      fill: ${theme.colors.white};
    }
    ${PictureIcon} {
      color: ${theme.colors.f300};
      background: ${theme.colors.f500};
    }
    ${Title} {
      color:${theme.colors.white};
    }
    ${Description} {
      color: ${theme.colors.f300};
    }
    ${Divider} {
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23D095F1' viewBox='0 0 12 2'%3E%3Crect width='8' height='2' x='2' rx='1'/%3E%3C/svg%3E%0A");
      &:before,
      &:after {
        border-color: ${theme.colors.white};
      }
    }
    ${TextFooter} {
      color: ${theme.colors.f300};
      font-weight: bold
    }
  `

export const Wrapper = styled('div')(baseStyles, baseActiveStyles)
